import clsx from 'clsx';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';

interface Props extends ComponentProps<typeof TooltipPrimitive.Provider> {
  contentProps?: {
    content: ReactNode;
    side?: 'top' | 'right' | 'bottom' | 'left' | undefined;
    align?: 'start' | 'end' | 'center' | undefined;
  };
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const HubertTooltip = ({ open, defaultOpen = false, onOpenChange, children, ...props }: Props) => {
  return (
    <TooltipPrimitive.Provider delayDuration={100} {...props}>
      <TooltipPrimitive.Root
        open={open !== undefined ? open : undefined}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
      >
        {children}
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};

type TriggerProps = ComponentProps<typeof TooltipPrimitive.Trigger>;

const Trigger = ({ children, ...props }: TriggerProps) => {
  return <TooltipPrimitive.Trigger {...props}>{children}</TooltipPrimitive.Trigger>;
};

interface ContentProps extends ComponentProps<typeof TooltipPrimitive.Content> {
  className?: string;
  arrowClassName?: string;
  showArrow?: boolean;
  portalContent?: boolean;
  portalElement?: HTMLElement;
}

const Content = ({
  portalContent = false,
  portalElement,
  className,
  arrowClassName,
  showArrow = true,
  children,
  ...props
}: ContentProps) => {
  if (portalContent) {
    return (
      <TooltipPrimitive.Portal container={portalElement}>
        <TooltipPrimitive.Content
          {...props}
          className={clsx('bg-black', 'max-w-[400px]', 'rounded-sm', 'text-white', 'text-xs', 'px-2 py-1', className)}
        >
          {children}
          {showArrow ? <TooltipPrimitive.Arrow width={11} height={5} className={arrowClassName} /> : null}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    );
  }

  return (
    <TooltipPrimitive.Content
      {...props}
      className={clsx('bg-black', 'max-w-[400px]', 'rounded-sm', 'text-white', 'text-xs', 'px-2 py-1', className)}
    >
      {children}
      {showArrow ? <TooltipPrimitive.Arrow width={11} height={5} className={arrowClassName} /> : null}
    </TooltipPrimitive.Content>
  );
};

HubertTooltip.Trigger = Trigger;
HubertTooltip.Content = Content;

export default HubertTooltip;
